import {
  selectCurrentRoles,
  selectCurrentUserName,
  selectUserId,
} from "features/api/auth/authSlice";
import { useAppSelector } from "hooks/reduxToolkit";
import { useReports } from "hooks/useReports";

export enum LocalStorageKey {
  Roles = "roles",
  UserId = "userId",
  UserName = "name",
  SelectedRole = "selectedRole",
}

export const useGetUserData = (key: LocalStorageKey) => {
  const Roles = useAppSelector(selectCurrentRoles);
  const UserId = useAppSelector(selectUserId);
  const UserName = useAppSelector(selectCurrentUserName);
  const { selectedRole } = useReports();

  switch (key) {
    case LocalStorageKey.Roles:
      return Roles.length > 0
        ? Roles
        : JSON.parse(localStorage.getItem(LocalStorageKey.Roles));
    case LocalStorageKey.UserId:
      return UserId || localStorage.getItem(LocalStorageKey.UserId);
    case LocalStorageKey.UserName:
      return UserName || localStorage.getItem(LocalStorageKey.UserName);
    case LocalStorageKey.SelectedRole:
      return (
        JSON.parse(localStorage.getItem(LocalStorageKey.SelectedRole)) ||
        selectedRole
      );
    default:
      return null;
  }
};
